<script setup>
import {computed} from "vue";
//import functions
//import components
import {
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  InputGroup,
  InputGroupAddon,
  InputText,
  FloatLabel,
  Select,
  Textarea,
  Rating,
} from "primevue";
import Attachments from "@/views/orders/Details/Attachments.vue";
import Users from "@/components/Users.vue";
//import stores
import {useUserStore} from "@/stores/user.js";
//import composables

//stores
const userStore = useUserStore();

//loading flags

//other composables

//emits

//props
const props = defineProps({
  orderType: {
    type: String,
    required: true
  }
})
//injects

//component variables
const hasProfitField = computed(() => userStore.hasPermission('BIG_BOSS') && props.orderType === 'Account')

//component functions

//hooks
</script>

<template>
  <Tabs value="0" class="custom-tabs">
    <div class="flex flex-row justify-between items-center border-b border-slate-700 pb-2">
      <TabList>
        <Tab value="0" disabled>Details</Tab>
        <Tab value="1" disabled>Attachments</Tab>
      </TabList>
      <div class="flex flex-row gap-2">
        <!--        <Rating readonly>
                  <template #onicon>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
                      <path stroke-width="2" stroke="#fcd53f" fill="#fcd53f"
                            d="m18.7 4.627l2.247 4.31a2.27 2.27 0 0 0 1.686 1.189l4.746.65c2.538.35 3.522 3.479 1.645 5.219l-3.25 2.999a2.23 2.23 0 0 0-.683 2.04l.793 4.398c.441 2.45-2.108 4.36-4.345 3.24l-4.536-2.25a2.28 2.28 0 0 0-2.006 0l-4.536 2.25c-2.238 1.11-4.786-.79-4.345-3.24l.793-4.399c.14-.75-.12-1.52-.682-2.04l-3.251-2.998c-1.877-1.73-.893-4.87 1.645-5.22l4.746-.65a2.23 2.23 0 0 0 1.686-1.189l2.248-4.309c1.144-2.17 4.264-2.17 5.398 0"/>
                    </svg>
                  </template>
                  <template #officon>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
                      <path stroke-width="2" stroke="#fcd53f" fill="transparent"
                            d="m18.7 4.627l2.247 4.31a2.27 2.27 0 0 0 1.686 1.189l4.746.65c2.538.35 3.522 3.479 1.645 5.219l-3.25 2.999a2.23 2.23 0 0 0-.683 2.04l.793 4.398c.441 2.45-2.108 4.36-4.345 3.24l-4.536-2.25a2.28 2.28 0 0 0-2.006 0l-4.536 2.25c-2.238 1.11-4.786-.79-4.345-3.24l.793-4.399c.14-.75-.12-1.52-.682-2.04l-3.251-2.998c-1.877-1.73-.893-4.87 1.645-5.22l4.746-.65a2.23 2.23 0 0 0 1.686-1.189l2.248-4.309c1.144-2.17 4.264-2.17 5.398 0"/>
                    </svg>
                  </template>
                </Rating>-->
        <div class="flex flex-col gap-0.5 animate-pulse">
          <FloatLabel class="w-full custom-select"
                      variant="on">
            <Select inputId="state" readonly disabled
                    class="w-full min-w-28 !bg-transparent h-[28px] 2xl:h-[32px] !text-xs 2xl:!text-sm"
                    input-class="!py-1 !items-center !flex !pr-0"
                    overlay-class="select-overlay-in-modal h-max">
            </Select>
          </FloatLabel>
        </div>
      </div>
    </div>
    <TabPanels>
      <TabPanel value="0">
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12">
            <div class="bg-slate-800 rounded-md p-3 border border-slate-700 animate-pulse">
              <h4 class="text-sm font-medium text-slate-300 mb-2">Preview Changes</h4>
              <div class="grid grid-cols-2 gap-4 text-xs">
                <div>
                  <p class="text-slate-400">New Takers Cut</p>
                  <p class="h-5 w-28 bg-slate-700 rounded-md"></p>
                </div>
                <div>
                  <p class="text-slate-400">New Revenue</p>
                  <p class="h-5 w-28 bg-slate-700 rounded-md"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-span-8 flex flex-col gap-0.5 animate-pulse">
            <FloatLabel variant="on">
              <InputText id="hotOrderTitle" autocomplete="off" readonly disabled
                         class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"/>
              <label for="hotOrderTitle" class="!bg-slate-900">Title</label>
            </FloatLabel>
          </div>
          <div class="col-span-4 flex flex-row gap-2 text-xs 2xl:text-sm">
            <div class="flex-1 w-full animate-pulse">
              <FloatLabel variant="on">
                <Select input-id="currency" readonly disabled
                        class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"
                        label-class="!text-sm !items-center !flex">
                </Select>
                <label for="currency" class="!bg-slate-900">Currency</label>
              </FloatLabel>
            </div>
            <button>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                   stroke="#a1a1aa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="lucide lucide-refresh-cw-icon lucide-refresh-cw">
                <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
                <path d="M21 3v5h-5"/>
                <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
                <path d="M8 16H3v5"/>
              </svg>
            </button>
          </div>
          <div class="flex flex-col gap-0.5 animate-pulse"
               :class="[hasProfitField ? 'col-span-3' : 'col-span-4']">
            <InputGroup>
              <FloatLabel variant="on">
                <InputText id="amount" autocomplete="off" readonly disabled
                           class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"/>
                <label for="amount" class="!bg-slate-900">Amount</label>
              </FloatLabel>
              <InputGroupAddon class="!bg-transparent !border-slate-700 h-full text-xs">

              </InputGroupAddon>
            </InputGroup>
          </div>
          <div class="flex flex-col gap-0.5 animate-pulse"
               :class="[hasProfitField ? 'col-span-3' : 'col-span-4']">
            <InputGroup>
              <FloatLabel variant="on">
                <InputText id="hotOrderPrice"
                           autocomplete="off" readonly disabled
                           class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"/>
                <label for="hotOrderPrice" class="!bg-slate-900">Rate</label>
              </FloatLabel>
              <InputGroupAddon class="!bg-transparent !border-slate-700 h-full text-xs">

              </InputGroupAddon>
            </InputGroup>
          </div>
          <div class="flex flex-col gap-0.5 animate-pulse"
               :class="[hasProfitField ? 'col-span-3' : 'col-span-4']">
            <InputGroup>
              <FloatLabel variant="on">
                <InputText id="value"
                           autocomplete="off" readonly disabled
                           class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"/>
                <label for="value" class="!bg-slate-900">Value</label>
              </FloatLabel>
              <InputGroupAddon class="!bg-transparent !border-slate-700 h-full text-xs">$
              </InputGroupAddon>
            </InputGroup>
          </div>
          <div v-if="hasProfitField"
               class="col-span-3 flex flex-col gap-0.5 animate-pulse">
            <InputGroup>
              <FloatLabel variant="on">
                <InputText id="profitMargin"
                           autocomplete="off" readonly disabled
                           class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"/>
                <label for="profitMargin" class="!bg-slate-900">Profit Margin</label>
              </FloatLabel>
              <InputGroupAddon class="!bg-transparent !border-slate-700 h-[32px] 2xl:h-[40px]">%
              </InputGroupAddon>
            </InputGroup>
          </div>
          <div class="col-span-12 flex flex-row gap-2 text-xs 2xl:text-sm">
            <div class="flex flex-col gap-0.5 text-xs 2xl:text-sm w-full animate-pulse">
              <Users appendTo="body" disabled readonly
                     label="Taker" :required="false"/>
            </div>
          </div>
          <div
              class="col-span-12 flex flex-row gap-2 w-full items-center border border-slate-700 rounded-md p-2 animate-pulse">
            <div
                class="flex items-center justify-center size-10 rounded-full border border-slate-700">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                   stroke-linejoin="round" class="lucide lucide-user-icon lucide-user">
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <div class="flex-1 grid grid-cols-2 gap-1">
              <div class="flex flex-col gap-2">
                <div class="border border-slate-700 h-5 w-40 rounded-sm"></div>
                <div class="border border-slate-700 h-5 w-40 rounded-sm"></div>
              </div>
              <div class="flex flex-col gap-2">
                <div class="border border-slate-700 h-5 w-40 rounded-sm"></div>
                <div class="border border-slate-700 h-5 w-40 rounded-sm"></div>
              </div>
            </div>
          </div>
          <div class="col-span-12 grid grid-cols-2 gap-4">
            <div class="flex flex-col gap-0.5 animate-pulse">
              <FloatLabel variant="on">
              <Textarea id="description" rows="5" style="resize: none" readonly disabled
                        class="!bg-transparent w-full rounded-md !text-xs 2xl:!text-sm !border-slate-700"/>
                <label for="description" class="!bg-slate-900">Description</label>
              </FloatLabel>
            </div>
            <div class="flex flex-col gap-0.5 animate-pulse">
              <FloatLabel variant="on">
              <Textarea id="notes" rows="5" style="resize: none" readonly disabled
                        class="!bg-transparent w-full rounded-md !text-xs 2xl:!text-sm !border-slate-700"/>
                <label for="notes" class="!bg-slate-900">Notes</label>
              </FloatLabel>
            </div>
          </div>
        </div>
      </TabPanel>
      <TabPanel value="1">
        <Attachments
            id="hotOrder"
            :count="16"
            :only-changes="true"
            size-class="w-24 h-24"
            font-size="text-[.6rem]"
        />
      </TabPanel>
    </TabPanels>
  </Tabs>
</template>
<style></style>